/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import moment from 'moment';
import { checkBatchNumber } from '../store/actions';
import { replaceCommaIntoWhiteSpace } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const checkBatch = async (batchNumberFromUser) => {
  const obj = {
    batchNumber: batchNumberFromUser.toString(),
  };
  const result = await checkBatchNumber(obj);

  if (result.message == 'SUCESS' && result.status == '001') {
    return result.data;
  }
  return 'API failed';
};

export const checkDateFormat = (valDate) => {
  const reTest = /[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2,4}$/;
  const dateFormat = 'MM/DD/YYYY';
  const dateFormat1 = 'YYYY-MM-DD';
  const dateFormat2 = 'MM/DD/YY';
  let newDate = false;
  if (reTest.test(valDate)) {
    if (
      moment(valDate, dateFormat, true).isValid() ||
      moment(valDate, dateFormat2, true).isValid()
    ) {
      let currtDate = moment(valDate, [dateFormat]);
      if (moment(valDate, dateFormat2, true).isValid()) {
        currtDate = moment(valDate, [dateFormat2]);
      }
      newDate = moment(currtDate).format(dateFormat);
    }
  }

  return newDate;
};

export const checkFutureDate = (date) => {
  const dateTime = moment().format('MM/DD/YYYY');
  const secondForm = moment().format('MM/DD/YY');

  if (
    moment(date).isSameOrBefore(dateTime) ||
    moment(date).isSameOrBefore(secondForm)
  ) {
    return true;
  }
  return false;
};

export const checkBackwardDate = (date) => {
  if (
    moment(date).isBefore('01/01/1992') ||
    moment(date).isBefore('01/01/92')
  ) {
    return false;
  }
  return true;
};

export const checkIfNum = (value) => {
  return /^\d+$/.test(value);
};

export const checkIfAmountNum = (value) => {
  const reg = /^[0-9]\d{0,9}(\.\d{1,2})?$/;

  return reg.test(replaceCommaIntoWhiteSpace(value));
};
